<template>
  <main>
    <news-filter :clubNews="clubNews" @filtered="updateFilteredNews"></news-filter>
    <news :news="filteredNews" origin="clubs"></news>
  </main>
</template>
<script>
import { onMounted, ref } from "vue";
import News from "./News.vue";
import NewsFilter from "./NewsFilter.vue";
import axios from 'axios';

export default {
  components: { NewsFilter, News },
  name: "Clubs",
  setup() {

    const clubNews = ref([]);
    const filteredNews = ref(clubNews.value);

    // Methode zum Aktualisieren der gefilterten Nachrichten
    const updateFilteredNews = (filtered) => {
      filteredNews.value = filtered;
    };

    const fetchData = async() => {
      try {
        const response = await axios.get('http://localhost:8082/gemeinde/news/news-not-in-clubid/1');
        clubNews.value = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    onMounted(() => {
      fetchData()
    })

    return { 
      clubNews,
      filteredNews,
      updateFilteredNews
     };
  }
};
</script>

<style></style>
